/**
 * This lib can be used everywhere (Nitro & Nuxt Context). If you are in the Nuxt Context, you can use "useSentry" via auto Imports.
 */
import { getClient, type EventHint, type SeverityLevel } from '@sentry/core';

export const captureException = (error: Error | unknown, hint?: EventHint) => {
  const sentryClient = getClient();
  if (sentryClient?.captureException) {
    return sentryClient.captureException(error, hint);
  }
  console.error(error);

  return 'event-id';
};

export const captureMessage = (
  error: string,
  level: SeverityLevel = 'info',
  hint: EventHint | undefined = undefined
) => {
  const sentryClient = getClient();
  if (sentryClient?.captureMessage) {
    return sentryClient.captureMessage(error, level, hint);
  }

  console.log(error);

  return 'event-id';
};
